module.exports = __webpack_public_path__ + "img/51_boat-back.34556e3a.jpg";